import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import { InjectedFormikProps, withFormik } from 'formik'

import Button        from '@material-ui/core/Button'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'
import MenuItem      from '@material-ui/core/MenuItem'

import { EnhancedTextField } from '../atoms'

import { sectors } from '../../project-utils/hardcoded'
import {
  genValueMapper,
  mapFormikToMuiProps,
  proxyFormikSubmission,
}                  from './form-utils'
import coachingExperienceSchema, {
  CoachingExperienceValues,
  emptyCoachingExperience,
}                  from './schemas/coaching-experience.schema'

interface AddCoachingExperienceDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (values: CoachingExperienceValues) => void
  close: () => void
}

type Props = InjectedFormikProps<AddCoachingExperienceDialogProps, CoachingExperienceValues>

const AddStudyDialog = (props: Props) => {
  const {
    isOpen,
    submitForm,
    close,
  } = props

  const mapper = mapFormikToMuiProps(props)

  return (
    <Dialog
      fullWidth
      open={isOpen}
    >
      <DialogTitle>
        <FormattedMessage id={'generic.addCoachingExperience'} />
      </DialogTitle>
      <DialogContent>
        <EnhancedTextField
          {...mapper('company')}
          fullWidth
          margin={'dense'}
        />
        <EnhancedTextField
          {...mapper('sector')}
          fullWidth
          select
          margin={'dense'}
        >
          {sectors.map(sector => (
            <MenuItem key={sector} value={sector}>
              <FormattedMessage id={`sectors.${sector}`} />
            </MenuItem>
          ))}
        </EnhancedTextField>
      </DialogContent>
      <DialogActions>
        <Button
          color={'primary'}
          onClick={close}
        >
          <FormattedMessage id={'buttonActions.cancel'} />
        </Button>
        <Button
          color={'primary'}
          onClick={submitForm}
        >
          <FormattedMessage id={'buttonActions.save'} />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withFormik<AddCoachingExperienceDialogProps, CoachingExperienceValues>({
  validationSchema: coachingExperienceSchema,
  mapPropsToValues: genValueMapper(emptyCoachingExperience),
  handleSubmit:     proxyFormikSubmission,
})(AddStudyDialog)



// WEBPACK FOOTER //
// ./src/components/forms/CoachingExperienceAddDialog.tsx